var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useMemo, useRef, useState } from "react";
import { SimpleForm, useGetList, useInfiniteGetList } from "react-admin";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useTranslation } from "react-i18next";
import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, Typography, } from "@mui/material";
import TextField from "@mui/material/TextField";
import { EStatus } from "@/types/TallySheets";
import { sortFunction, translateSharedValidationError, VALIDATION_ERROR_CODES, } from "./utils";
import { EEnableCheckableLists, TallySheetVotingChannel, isTallySheetVotingChannel, } from "@sequentech/ui-core";
import { validate_area_contest_results_js, validate_ballot_box_blank_ballots_js } from "sequent-core";
import { filterCandidateByCheckableLists } from "@/services/CandidatesFilter";
import { createTree, getContestMatches } from "@/services/AreaService";
import { styled } from "@mui/material/styles";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { normalizeAreaContestResults } from "./validation";
var StyledError = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    margin-top: 3px;\n    font-size: 0.85rem;\n"], ["\n    color: ", ";\n    margin-top: 3px;\n    font-size: 0.85rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.red.main;
});
var votingChannels = [TallySheetVotingChannel.Paper, TallySheetVotingChannel.Postal];
var validateAreaContestResults = function (content, contestBounds) {
    return validate_area_contest_results_js(normalizeAreaContestResults(content), contestBounds);
};
// `blank_ballots` is a ballot-box property replicated onto every contest sheet of the
// box (like total_declined_to_vote), so it must be cross-checked against every other
// contest sheet of the same (channel, area) box, not just validated in isolation.
var validateBallotBoxBlankBallots = function (contestSheets) {
    return validate_ballot_box_blank_ballots_js(contestSheets.map(normalizeAreaContestResults));
};
var numbersRegExp = /^[0-9]+$/;
export var EditTallySheet = function (props) {
    var _a;
    var tallySheet = props.tallySheet, election = props.election, doCreatedTalySheet = props.doCreatedTalySheet, submitRef = props.submitRef, setIsButtonDisabled = props.setIsButtonDisabled, choosenContest = props.choosenContest, setChoosenContest = props.setChoosenContest;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var aliasRenderer = useAliasRenderer();
    var translateValidationError = function (error) {
        return translateSharedValidationError(t, error);
    };
    var _c = useState([]), areasList = _c[0], setAreasList = _c[1];
    var _d = useState([]), contestList = _d[0], setContestList = _d[1];
    var _e = React.useState(null), channel = _e[0], setChannel = _e[1];
    var _f = useState(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return normalizeAreaContestResults({
            area_id: (tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.area_id) || "",
            contest_id: (_b = (_a = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.id) !== null && _a !== void 0 ? _a : tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id) !== null && _b !== void 0 ? _b : "",
            total_votes: ((_c = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _c === void 0 ? void 0 : _c.total_votes) || 0,
            total_valid_votes: ((_d = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _d === void 0 ? void 0 : _d.total_valid_votes) || 0,
            invalid_votes: ((_e = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _e === void 0 ? void 0 : _e.invalid_votes) || {},
            total_blank_votes: ((_f = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _f === void 0 ? void 0 : _f.total_blank_votes) || 0,
            blank_ballots: (_g = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _g === void 0 ? void 0 : _g.blank_ballots,
            census: (_h = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _h === void 0 ? void 0 : _h.census,
            candidate_results: ((_j = tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.content) === null || _j === void 0 ? void 0 : _j.candidate_results) || {},
        });
    }), results = _f[0], setResults = _f[1];
    var _g = useState({}), invalids = _g[0], setInvalids = _g[1];
    var _h = useState([]), candidatesResults = _h[0], setCandidatesResults = _h[1];
    var _j = useState(null), areaNameFilter = _j[0], setAreaNameFilter = _j[1];
    var _k = useState(null), contestNameFilter = _k[0], setContestNameFilter = _k[1];
    var _l = useState([]), areaIds = _l[0], setAreaIds = _l[1];
    var _m = useState([]), sharedValidationErrors = _m[0], setSharedValidationErrors = _m[1];
    var _o = useState(false), blankBallotsInconsistentError = _o[0], setBlankBallotsInconsistentError = _o[1];
    var _p = useState(false), blankBallotsOutOfBoundsError = _p[0], setBlankBallotsOutOfBoundsError = _p[1];
    var areaContests = useGetList("sequent_backend_area_contest", {
        filter: {
            tenant_id: election.tenant_id,
            election_event_id: election.election_event_id,
            election_id: election.id,
        },
        pagination: {
            perPage: 10000, // Setting initial larger records size of areas
            page: 1,
        },
    }).data;
    var contests = useGetList("sequent_backend_contest", {
        filter: {
            tenant_id: election.tenant_id,
            election_event_id: election.election_event_id,
            election_id: election.id,
        },
        pagination: {
            perPage: 10000, // Setting initial larger records size of areas
            page: 1,
        },
    }).data;
    var allAreas = useGetList("sequent_backend_area", {
        filter: {
            tenant_id: election.tenant_id,
            election_event_id: election.election_event_id,
            election_id: election.id,
        },
        pagination: {
            perPage: 10000, // Setting initial larger records size of areas
            page: 1,
        },
    }).data;
    var _q = useGetList("sequent_backend_area", {
        filter: {
            tenant_id: election.tenant_id,
            election_event_id: election.election_event_id,
            election_id: election.id,
            name: areaNameFilter !== null && areaNameFilter !== void 0 ? areaNameFilter : "",
            id: {
                format: "hasura-raw-query",
                value: { _in: areaIds },
            },
            /*parent_id: {
            format: "hasura-raw-query",
            value: {_is_null: true},
        },*/
        },
        pagination: {
            perPage: 10000, // Setting initial larger records size of areas
            page: 1,
        },
    }), areas = _q.data, refetchAreas = _q.refetch;
    var _r = useInfiniteGetList("sequent_backend_candidate", {
        filter: {
            contest_id: (_a = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.id) !== null && _a !== void 0 ? _a : tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id,
            tenant_id: election.tenant_id,
            election_event_id: election.election_event_id,
        },
        pagination: { page: 1, perPage: 50 },
    }, { enabled: !!choosenContest || !!(tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id) }), fetchedCandidates = _r.data, hasNextPage = _r.hasNextPage, fetchNextPage = _r.fetchNextPage, refetchCandidates = _r.refetch;
    // Latest approved sheets of every other contest in the same (channel, area) ballot
    // box, so blank_ballots can be cross-checked for consistency and bounds the same
    // way the CSV import pipeline already does (windmill's preview_tally_sheet_import).
    var siblingTallySheets = useGetList("sequent_backend_tally_sheet", {
        filter: {
            tenant_id: election.tenant_id,
            election_event_id: election.election_event_id,
            election_id: election.id,
            area_id: results.area_id,
            channel: { format: "hasura-raw-query", value: { _eq: channel } },
            status: { format: "hasura-raw-query", value: { _eq: EStatus.APPROVED } },
            deleted_at: { format: "hasura-raw-query", value: { _is_null: true } },
        },
        sort: { field: "version", order: "DESC" },
        pagination: { perPage: 10000, page: 1 },
    }, { enabled: !!results.area_id && !!channel }).data;
    var siblingBoxSheets = useMemo(function () {
        var latestByContest = new Map();
        for (var _i = 0, _a = siblingTallySheets !== null && siblingTallySheets !== void 0 ? siblingTallySheets : []; _i < _a.length; _i++) {
            var sheet = _a[_i];
            if (sheet.contest_id === results.contest_id || !sheet.content) {
                continue;
            }
            if (!latestByContest.has(sheet.contest_id)) {
                latestByContest.set(sheet.contest_id, normalizeAreaContestResults(__assign({}, sheet.content)));
            }
        }
        return Array.from(latestByContest.values());
    }, [siblingTallySheets, results.contest_id]);
    var checkableLists = useMemo(function () {
        var _a;
        var presentation = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.presentation;
        return (_a = presentation === null || presentation === void 0 ? void 0 : presentation.enable_checkable_lists) !== null && _a !== void 0 ? _a : EEnableCheckableLists.CANDIDATES_AND_LISTS;
    }, [choosenContest]);
    var candidates = useMemo(function () {
        //force fetch all records
        hasNextPage && fetchNextPage();
        return fetchedCandidates === null || fetchedCandidates === void 0 ? void 0 : fetchedCandidates.pages.flatMap(function (item) { return item.data; });
    }, [fetchedCandidates]);
    var uniqueElements = function (arr) {
        var uniqueObj = {};
        var uniqueArr = [];
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var item = arr_1[_i];
            if (!uniqueObj[item]) {
                uniqueObj[item] = true;
                uniqueArr.push(item);
            }
        }
        return uniqueArr;
    };
    useEffect(function () {
        var _a;
        var treeNodeAreas = (allAreas !== null && allAreas !== void 0 ? allAreas : []).map(function (area) { return ({
            id: area.id,
            tenant_id: area.tenant_id,
            election_event_id: area.election_event_id,
            parent_id: area.parent_id,
        }); });
        var treeAreaContests = (areaContests !== null && areaContests !== void 0 ? areaContests : []).map(function (areaContest) { return ({
            id: areaContest.id,
            area_id: areaContest.area_id,
            contest_id: areaContest.contest_id,
        }); });
        var tree = createTree(treeNodeAreas, treeAreaContests);
        var selectedContestId = (_a = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.id) !== null && _a !== void 0 ? _a : tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id;
        if (!selectedContestId) {
            setAreaIds([]);
            return;
        }
        var matchedAreaContests = getContestMatches(tree, selectedContestId);
        var matchedAreas = matchedAreaContests.map(function (area) { return area.area_id; });
        var uniqueAreas = uniqueElements(matchedAreas);
        setAreaIds(uniqueAreas);
    }, [areaContests, allAreas, choosenContest, tallySheet]);
    useEffect(function () {
        var _a;
        var tallySaved = localStorage.getItem("tallySheetData");
        if ((tallySheet || tallySaved) && candidates) {
            var tallySheetTemp = tallySaved ? JSON.parse(tallySaved || "") : tallySheet;
            if (tallySheetTemp.content) {
                var contentTemp = normalizeAreaContestResults(__assign({}, tallySheetTemp.content));
                setInvalids((_a = contentTemp.invalid_votes) !== null && _a !== void 0 ? _a : {});
                if (contentTemp.candidate_results) {
                    var candidatesResultsTemp = [];
                    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
                        var candidate = candidates_1[_i];
                        var isValid = filterCandidateByCheckableLists(candidate, checkableLists);
                        if (!isValid) {
                            continue;
                        }
                        var candidateTemp = {
                            candidate_id: candidate.id,
                            name: aliasRenderer(candidate.presentation),
                        };
                        if (contentTemp.candidate_results[candidate.id]) {
                            candidateTemp.total_votes =
                                contentTemp.candidate_results[candidate.id].total_votes;
                        }
                        candidatesResultsTemp.push(candidateTemp);
                    }
                    candidatesResultsTemp.sort(sortFunction);
                    setCandidatesResults(candidatesResultsTemp);
                }
                setResults(contentTemp);
            }
            setChannel(tallySheetTemp.channel && isTallySheetVotingChannel(tallySheetTemp.channel)
                ? tallySheetTemp.channel
                : null);
        }
    }, [tallySheet, candidates, i18n.language]);
    useEffect(function () {
        if (election) {
            setResults(function (prev) {
                var _a, _b;
                return (__assign(__assign({}, prev), { contest_id: (_b = (_a = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.id) !== null && _a !== void 0 ? _a : tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id) !== null && _b !== void 0 ? _b : "" }));
            });
        }
    }, [election]);
    useEffect(function () {
        if (areas) {
            var areatListTemp = areas === null || areas === void 0 ? void 0 : areas.map(function (item) {
                return {
                    id: item.id,
                    label: item.name,
                };
            });
            setAreasList(areatListTemp);
        }
    }, [areas]);
    useEffect(function () {
        if (contests) {
            var contestsListTemp = contests === null || contests === void 0 ? void 0 : contests.map(function (item) {
                return {
                    id: item.id,
                    label: aliasRenderer(item.presentation),
                };
            });
            setContestList(contestsListTemp);
        }
    }, [contests, i18n.language]);
    useEffect(function () {
        window.scrollTo(0, 0);
    }, []);
    useEffect(function () {
        var tallySaved = localStorage.getItem("tallySheetData");
        if (!(tallySheet || tallySaved) && candidates) {
            var candidatesTemp = [];
            for (var _i = 0, candidates_2 = candidates; _i < candidates_2.length; _i++) {
                var candidate = candidates_2[_i];
                var isValid = filterCandidateByCheckableLists(candidate, checkableLists);
                if (!isValid) {
                    continue;
                }
                var candidateTemp = {
                    candidate_id: candidate.id,
                    name: aliasRenderer(candidate.presentation),
                };
                candidatesTemp.push(candidateTemp);
            }
            candidatesTemp.sort(sortFunction);
            setCandidatesResults(candidatesTemp);
        }
    }, [candidates, tallySheet, i18n.language]);
    var recalculateTotals = function () {
        var _a, _b, _c;
        var normalizedResults = normalizeAreaContestResults(results);
        var normalizedInvalids = (_a = normalizeAreaContestResults(__assign(__assign({}, normalizedResults), { invalid_votes: invalids }))
            .invalid_votes) !== null && _a !== void 0 ? _a : {};
        var totalValidVotes = (_b = normalizedResults.total_valid_votes) !== null && _b !== void 0 ? _b : 0;
        var totalVotes = totalValidVotes + ((_c = normalizedInvalids.total_invalid) !== null && _c !== void 0 ? _c : 0);
        var newResults = __assign(__assign({}, normalizedResults), { total_votes: totalVotes });
        var candidateResultsForValidation = {};
        for (var _i = 0, candidatesResults_1 = candidatesResults; _i < candidatesResults_1.length; _i++) {
            var candidateResult = candidatesResults_1[_i];
            candidateResultsForValidation[candidateResult.candidate_id] = {
                candidate_id: candidateResult.candidate_id,
                total_votes: candidateResult.total_votes,
            };
        }
        var currentSheetForValidation = __assign(__assign({}, newResults), { invalid_votes: normalizedInvalids, candidate_results: candidateResultsForValidation });
        var contestPresentation = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.presentation;
        var sharedValidationErrors = validateAreaContestResults(currentSheetForValidation, {
            max_votes: choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.max_votes,
            counting_algorithm: choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.counting_algorithm,
            cumulative_number_of_checkboxes: contestPresentation === null || contestPresentation === void 0 ? void 0 : contestPresentation.cumulative_number_of_checkboxes,
        });
        setSharedValidationErrors(sharedValidationErrors);
        var boxCheck = newResults.area_id && newResults.contest_id
            ? validateBallotBoxBlankBallots(__spreadArray([currentSheetForValidation], siblingBoxSheets, true))
            : { errors: [] };
        var boxCodes = new Set(boxCheck.errors.map(function (error) { return error.code; }));
        setBlankBallotsInconsistentError(boxCodes.has("inconsistent_blank_ballots"));
        setBlankBallotsOutOfBoundsError(boxCodes.has("blank_ballots_out_of_bounds"));
        // Mirrors windmill's CSV import: only offer the bounds-implied value when the
        // operator hasn't supplied one, never overwrite an existing entry.
        var finalResults = newResults;
        if (typeof boxCheck.pre_filled_value === "number" &&
            typeof newResults.blank_ballots !== "number") {
            finalResults = __assign(__assign({}, newResults), { blank_ballots: boxCheck.pre_filled_value });
        }
        // Box-check errors are a warning, not a hard block: siblingBoxSheets only sees
        // already-APPROVED sheets, so correcting a wrong approved value one contest at a
        // time necessarily disagrees with the not-yet-corrected siblings until every
        // contest of the box has been fixed and approved. Blocking here would make that
        // correction impossible one sheet at a time. Only this sheet's own internal
        // arithmetic (sharedValidationErrors) blocks submission.
        setIsButtonDisabled(sharedValidationErrors.length > 0);
        if (JSON.stringify(finalResults) !== JSON.stringify(results)) {
            setResults(finalResults);
        }
    };
    useEffect(recalculateTotals, [
        results,
        candidatesResults,
        results.total_blank_votes,
        results.total_valid_votes,
        invalids === null || invalids === void 0 ? void 0 : invalids.total_invalid,
        invalids,
        choosenContest,
        siblingBoxSheets,
    ]);
    var handleChange = function (event, value, reason, details) {
        // setArea(event.target.value as string)
        setResults(function (prev) { return (__assign(__assign({}, prev), { area_id: value === null || value === void 0 ? void 0 : value.id })); });
    };
    var handleContestChange = function (event, value, reason, details) {
        setResults(function (prev) { return (__assign(__assign({}, prev), { contest_id: value === null || value === void 0 ? void 0 : value.id })); });
        setChoosenContest(contests === null || contests === void 0 ? void 0 : contests.find(function (contest) { return contest.id === (value === null || value === void 0 ? void 0 : value.id); }));
    };
    var handleTextChange = function (event) {
        setResults(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = event.target.value, _a)));
        });
    };
    var handleNumberChange = function (event) {
        if (event.target.value === "") {
            setResults(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = undefined, _a)));
            });
        }
        else if (event.target.value === "0") {
            setResults(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = 0, _a)));
            });
        }
        else {
            if (event.target.value.match(numbersRegExp)) {
                setResults(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = +event.target.value, _a)));
                });
            }
        }
    };
    var handleCensusChange = function (event) {
        var census = 0;
        if (event.target.value.match(numbersRegExp)) {
            census = Number(event.target.value);
        }
        setResults(__assign(__assign({}, results), { census: census }));
    };
    var handleInvalidChange = function (event) {
        var _a, _b;
        var newInvalid = __assign({}, invalids);
        var key = event.target.name;
        if (event.target.value === "") {
            newInvalid[key] = 0;
        }
        else if (event.target.value.match(numbersRegExp)) {
            newInvalid[key] = Number(event.target.value);
        }
        newInvalid.total_invalid =
            ((_a = newInvalid.explicit_invalid) !== null && _a !== void 0 ? _a : 0) + ((_b = newInvalid.implicit_invalid) !== null && _b !== void 0 ? _b : 0);
        setInvalids(newInvalid);
    };
    var handleCandidateChange = function (event) {
        var candidateTemp = candidatesResults.find(function (item) { return item.candidate_id === event.target.id; });
        var candidateRest = candidatesResults.filter(function (item) { return item.candidate_id !== event.target.id; });
        if (candidateTemp) {
            if (!event.target.value) {
                delete candidateTemp.total_votes;
            }
            else {
                if (event.target.value.match(numbersRegExp)) {
                    candidateTemp.total_votes = +event.target.value;
                }
                else {
                    candidateTemp.total_votes = +((candidateTemp === null || candidateTemp === void 0 ? void 0 : candidateTemp.total_votes) || 0);
                }
            }
            var finalCandidates = __spreadArray(__spreadArray([], candidateRest, true), [candidateTemp], false);
            finalCandidates.sort(function (a, b) { return a.name.localeCompare(b.name); });
            setCandidatesResults(finalCandidates);
        }
    };
    var areaSearchTimeoutId = useRef(undefined);
    var debouncedSearchArea = function (event) {
        var value = event.target.value;
        clearTimeout(areaSearchTimeoutId.current);
        areaSearchTimeoutId.current = setTimeout(function () {
            setAreaNameFilter(value ? value.trim() : null);
            refetchAreas();
        }, 350);
    };
    var contestSearchTimeoutId = useRef(undefined);
    var debouncedSearchContest = function (event) {
        var value = event.target.value;
        clearTimeout(contestSearchTimeoutId.current);
        contestSearchTimeoutId.current = setTimeout(function () {
            setContestNameFilter(value ? value.trim() : null);
        }, 350);
    };
    var onSubmit = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var candidatesResultsTemp, _i, candidatesResults_2, candidate, candidateTemp, resultsTemp, tallySheetData;
        var _a;
        return __generator(this, function (_b) {
            candidatesResultsTemp = {};
            for (_i = 0, candidatesResults_2 = candidatesResults; _i < candidatesResults_2.length; _i++) {
                candidate = candidatesResults_2[_i];
                candidateTemp = {
                    candidate_id: candidate.candidate_id,
                    total_votes: candidate.total_votes,
                };
                candidatesResultsTemp[candidate.candidate_id] = candidateTemp;
            }
            resultsTemp = normalizeAreaContestResults(__assign(__assign({}, results), { invalid_votes: invalids, candidate_results: candidatesResultsTemp }));
            tallySheetData = {
                tenant_id: election.tenant_id,
                election_event_id: election.election_event_id,
                election_id: election.id,
                contest_id: (_a = choosenContest === null || choosenContest === void 0 ? void 0 : choosenContest.id) !== null && _a !== void 0 ? _a : tallySheet === null || tallySheet === void 0 ? void 0 : tallySheet.contest_id,
                area_id: resultsTemp.area_id,
                channel: channel || "",
                content: resultsTemp,
            };
            if (tallySheet) {
                tallySheetData.id = tallySheet.id;
            }
            localStorage.setItem("tallySheetData", JSON.stringify(tallySheetData));
            if (doCreatedTalySheet) {
                doCreatedTalySheet(tallySheetData);
            }
            return [2 /*return*/];
        });
    }); };
    var currentArea = useMemo(function () { return areasList.find(function (area) { return area.id === (results === null || results === void 0 ? void 0 : results.area_id); }) || null; }, [results === null || results === void 0 ? void 0 : results.area_id, areasList]);
    var currentContest = useMemo(function () { return contestList.find(function (contest) { return contest.id === (results === null || results === void 0 ? void 0 : results.contest_id); }) || null; }, [results === null || results === void 0 ? void 0 : results.contest_id, contestList]);
    var filteredContestList = useMemo(function () {
        if (!contestNameFilter) {
            return contestList;
        }
        var needle = contestNameFilter.toLowerCase();
        return contestList.filter(function (contest) { var _a; return (_a = contest.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(needle); });
    }, [contestList, contestNameFilter]);
    useEffect(function () {
        if (choosenContest) {
            refetchCandidates();
        }
    }, [choosenContest]);
    var totalValidVotesError = sharedValidationErrors.find(function (error) { return error.code === VALIDATION_ERROR_CODES.INVALID_TOTAL_VALID_VOTES; });
    var censusExceededError = sharedValidationErrors.find(function (error) { return error.code === VALIDATION_ERROR_CODES.TOTAL_VOTES_EXCEEDS_CENSUS; });
    var otherValidationErrors = sharedValidationErrors.filter(function (error) {
        return error.code !== VALIDATION_ERROR_CODES.INVALID_TOTAL_VALID_VOTES &&
            error.code !== VALIDATION_ERROR_CODES.TOTAL_VOTES_EXCEEDS_CENSUS;
    });
    return (_jsx(SimpleForm, { toolbar: false, onSubmit: onSubmit, children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("tallysheet.common.subtitle") }), _jsx(FormControl, { fullWidth: true, size: "small", children: _jsx(Autocomplete, { sx: { width: 300 }, onChange: handleContestChange, options: filteredContestList !== null && filteredContestList !== void 0 ? filteredContestList : [], getOptionLabel: function (option) {
                            return typeof option.label === "string" ? option.label : option.id;
                        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: "Search Contest", onChange: debouncedSearchContest, value: contestNameFilter, required: true }))); }, value: currentContest, isOptionEqualToValue: function (a, b) { return a.id === b.id; } }) }), _jsx(FormControl, { fullWidth: true, size: "small", children: _jsx(Autocomplete, { sx: { width: 300 }, onChange: handleChange, options: areasList !== null && areasList !== void 0 ? areasList : [], getOptionLabel: function (option) {
                            return typeof option.label === "string" ? option.label : option.id;
                        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: "Search Area", onChange: debouncedSearchArea, value: areaNameFilter, required: true }))); }, value: currentArea, isOptionEqualToValue: function (a, b) { return a.id === b.id; } }) }), _jsxs(FormControl, { size: "small", sx: { width: 300 }, children: [_jsx(InputLabel, { children: t("tallysheet.label.channel") }), _jsx(Select, { name: "channel", value: channel || "", label: String(t("tallysheet.label.channel")), onChange: function (e) {
                                var value = e.target.value;
                                setChannel(isTallySheetVotingChannel(value) ? value : null);
                            }, required: true, children: votingChannels.map(function (votingChannel) { return (_jsx(MenuItem, { value: votingChannel, children: votingChannel }, votingChannel)); }) })] }), _jsx(PageHeaderStyles.Wrapper, { children: _jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.data") }) }), _jsx(TextField, { label: String(t("tallysheet.label.contest_id")), name: "constest_id", value: results.contest_id, onChange: handleTextChange, size: "small", style: { display: "none" }, required: true }), _jsx(TextField, { label: String(t("tallysheet.label.total_votes")), name: "total_votes", value: typeof results.total_votes === "number" ? results.total_votes : "", onChange: handleNumberChange, size: "small", required: true, disabled: true }), _jsxs(_Fragment, { children: [_jsx(TextField, { label: String(t("tallysheet.label.total_valid_votes")), name: "total_valid_votes", value: typeof results.total_valid_votes === "number"
                                ? results.total_valid_votes
                                : "", onChange: handleNumberChange, size: "small", required: true }), totalValidVotesError && (_jsx(StyledError, { children: translateValidationError(totalValidVotesError) })), otherValidationErrors.map(function (error) {
                            var _a;
                            return (_jsx(StyledError, { children: translateValidationError(error) }, error.code + ((_a = error.field) !== null && _a !== void 0 ? _a : "")));
                        })] }), _jsxs(Box, { sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                    }, children: [_jsx(TextField, { label: String(t("tallysheet.label.total_invalid")), name: "total_invalid", value: typeof invalids.total_invalid === "number" ? invalids.total_invalid : "", onChange: handleInvalidChange, size: "small", required: true, disabled: true }), _jsx(TextField, { label: String(t("tallysheet.label.implicit_invalid")), name: "implicit_invalid", value: typeof invalids.implicit_invalid === "number"
                                ? invalids.implicit_invalid
                                : "", onChange: handleInvalidChange, size: "small", required: true }), _jsx(TextField, { label: String(t("tallysheet.label.explicit_invalid")), name: "explicit_invalid", value: typeof invalids.explicit_invalid === "number"
                                ? invalids.explicit_invalid
                                : "", onChange: handleInvalidChange, size: "small", required: true })] }), _jsx(TextField, { label: String(t("tallysheet.label.total_blank_votes")), name: "total_blank_votes", value: typeof results.total_blank_votes === "number"
                        ? results.total_blank_votes
                        : "", onChange: handleNumberChange, size: "small", required: true }), _jsxs(_Fragment, { children: [_jsx(TextField, { label: String(t("tallysheet.label.blank_ballots")), name: "blank_ballots", value: typeof results.blank_ballots === "number" ? results.blank_ballots : "", onChange: handleNumberChange, size: "small" }), blankBallotsInconsistentError && (_jsx(StyledError, { children: t("tallysheet.inputError.blankBallotsInconsistent") })), blankBallotsOutOfBoundsError && (_jsx(StyledError, { children: t("tallysheet.inputError.blankBallotsOutOfBounds") }))] }), _jsxs(_Fragment, { children: [_jsx(TextField, { label: String(t("tallysheet.label.census")), name: "census", value: typeof results.census === "number" ? results.census : "", onChange: handleCensusChange, size: "small", required: true }), censusExceededError && (_jsx(StyledError, { children: translateValidationError(censusExceededError) }))] }), _jsx(PageHeaderStyles.Wrapper, { children: _jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.candidates") }) }), candidatesResults.map(function (candidate) { return (_jsxs(Box, { sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                    }, children: [_jsx(Typography, { variant: "body1", sx: { width: "50%" }, children: candidate.name }), _jsx(TextField, { id: candidate.candidate_id, label: String(t("tallysheet.label.total_votes")), name: "total_votes", value: candidate.total_votes, onChange: handleCandidateChange, size: "small", required: true })] }, candidate.candidate_id)); }), _jsx("button", { ref: submitRef, type: "submit", style: { display: "none" } })] }) }));
};
var templateObject_1;
